var nt = Object.defineProperty;
var rt = (e, t, n) => t in e ? nt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var c = (e, t, n) => (rt(e, typeof t != "symbol" ? t + "" : t, n), n);
function T(e) {
  return new Promise((t) => setTimeout(t, Math.max(0, e)));
}
function Zt() {
}
async function Kt() {
}
function Xt() {
  return Date.now().toString(36) + Math.random().toString(36).slice(-4);
}
const S = (e, t) => Math.round(e * 100) / 100 + " " + t, k = 1024 * 1024, I = 1024 * k, zt = (e) => e === void 0 ? "--" : e <= 0 ? "unknown" : e < 1024 ? "~1K" : e < k ? S(e / 1024, "K") : e < I ? S(e / k, "M") : S(e / I, "G"), Gt = async function(e) {
  return navigator.clipboard ? await navigator.clipboard.writeText(e).then(() => !0).catch(() => !1) : !1;
}, Yt = function(e = !1, t) {
  const n = (t || navigator.userAgent).toLowerCase(), r = /(?:iphone|ipad|ipod|ios)/.test(n) ? "ios" : /(?:android|adr )/.test(n) ? "android" : /(?:mobile|\bhpwos\b|symbianos|\bwindows phone os\b)/.test(n) ? "other" : "pc";
  return e && /ipad/.test(n) ? "pc" : r;
}, te = function(e, t) {
  return `data:image/svg+xml;charset=utf-8,<svg viewBox="0 0 ${e} ${t}" width="${e}" height="${t}" xmlns="http://www.w3.org/2000/svg"></svg>`;
};
class ee {
  constructor(t) {
    c(this, "taskList");
    c(this, "failedData");
    c(this, "consumer");
    c(this, "aborter");
    c(this, "checker");
    c(this, "onClear");
    c(this, "onFailed");
    c(this, "interval");
    c(this, "consumeStep");
    c(this, "waitWhenInit");
    c(this, "consumingData");
    c(this, "running");
    this.taskList = [], this.failedData = [], this.consumer = t.consumer, this.aborter = t.aborter || null, this.checker = t.checker || null, this.onClear = t.onClear || null, this.onFailed = t.onFailed || null, this.interval = Math.max(0, t.interval || 0), this.consumeStep = Math.max(1, Math.ceil(t.consumeStep || 1)), this.waitWhenInit = !!t.waitWhenInit, this.consumingData = null, this.running = !1;
  }
  /**
   * 向队列中插入一条任务数据
   */
  async push(t) {
    this.checker && await this.checker(t, this.taskList, this.consumingData) === !1 || (this.taskList.push(t), !(this.running || !this.consumer) && (this.running = !0, await T(this.waitWhenInit ? this.interval : 0), await this.consumeLoop(), this.running = !1));
  }
  /**
   * 检查队列的状态
   */
  status() {
    return {
      running: this.running,
      interval: this.interval,
      consumeStep: this.consumeStep,
      taskNumber: this.taskList.length,
      failedNumber: this.failedData.length
    };
  }
  /**
   * 重试失败任务
   */
  retryFailedData() {
    const t = this.failedData;
    if (t.length !== 0) {
      this.failedData = [];
      for (const n of t)
        this.push(n);
    }
  }
  /**
   * 取消当前进行中的任务，但并不会停止整个任务队列的继续进行
   *
   * 如果需要取消当前任务并停止队列，请使用 stop 方法
   */
  async abort() {
    this.aborter && this.consumingData && await this.aborter(this.consumingData);
  }
  /**
   * 清空任务队列和失败数据，但不会阻止正在处理中的任务
   *
   * 如果需要取消当前任务并停止队列，请使用 stop 方法
   */
  clear() {
    this.taskList.length = 0, this.failedData.length = 0;
  }
  /**
   * 清空任务队列和失败数据，并取消进行中的任务
   */
  async stop() {
    this.clear(), await this.abort();
  }
  async consumeLoop() {
    if (this.taskList.length === 0) {
      this.onClear && this.onClear();
      return;
    }
    const t = this.taskList.splice(0, this.consumeStep);
    this.consumingData = t;
    try {
      await this.consumer(t);
    } catch (n) {
      console.error("[Queue Task Failed]", n), this.failedData.push(...t), this.onFailed && this.onFailed(t);
    }
    this.consumingData = null, await T(this.interval), await this.consumeLoop();
  }
}
async function ne(e, t, n) {
  const r = Array.isArray(e) ? e : e.source, i = ("maxLine" in e ? e.maxLine : t) ?? 3, s = r.length, o = Math.max(2, Math.min(Math.ceil(i), s)), u = "worker" in e ? e.worker : n, l = "strict" in e ? !!e.strict : !1;
  let f = 0;
  const a = [], p = async function() {
    if (f === s)
      return;
    const d = f++;
    try {
      a[d] = await u(r[d], d, () => {
        f = s;
      });
    } catch (g) {
      console.log(g), l && (f = s);
    }
    await p();
  }, h = [];
  for (; f < o; )
    h.push(p());
  return await Promise.all(h), a;
}
function it(e) {
  const t = e || "CustomError";
  return class extends Error {
    constructor(n) {
      super(n), Object.defineProperty(this, "name", {
        value: t,
        enumerable: !1,
        configurable: !0
      }), "setPrototypeOf" in Object && Object.setPrototypeOf(this, new.target.prototype), "captureStackTrace" in Error && Error.captureStackTrace(this, this.constructor);
    }
  };
}
const re = it();
class ie {
  constructor() {
    c(this, "fnCache");
    c(this, "msgCache");
    this.fnCache = {}, this.msgCache = {};
  }
  emitMsgToHandler(t, n) {
    try {
      n(t);
    } catch (r) {
      console.error("EventBusHandlerError", r);
    }
  }
  /**
   * 发布一个消息
   * @param name    事件名称
   * @param payload 消息负载
   * @param shouldConsumed  消息是否必须被消费，如果没有注册事件则将被缓存至第一个 handler 之后，默认 false
   */
  emit(t, n, r = !1) {
    var s;
    const i = this.fnCache[t];
    if (!i || i.length === 0) {
      r && (this.msgCache[t] = this.msgCache[t] || [], (s = this.msgCache[t]) == null || s.push(n));
      return;
    }
    i.forEach((o) => this.emitMsgToHandler(n, o.fn)), this.fnCache[t] = i.filter((o) => !o.once);
  }
  /**
   * 注册一个监听函数
   * @param name 事件名称
   * @param handler 消息处理函数
   */
  on(t, n) {
    var i;
    this.fnCache[t] = this.fnCache[t] || [], (i = this.fnCache[t]) == null || i.push({ fn: n, once: !1 });
    const r = this.msgCache[t];
    return r && r.length > 0 && (r.forEach((s) => this.emitMsgToHandler(s, n)), delete this.msgCache[t]), n;
  }
  /**
   * 注册一次性监听函数
   * @param name 事件名称
   * @param handler 消息处理函数
   */
  once(t, n) {
    var s;
    this.fnCache[t] = this.fnCache[t] || [];
    const r = this.msgCache[t] || [];
    if (r.length === 0)
      return (s = this.fnCache[t]) == null || s.push({ fn: n, once: !0 }), n;
    const i = r.shift();
    return this.emitMsgToHandler(i, n), r.length === 0 ? delete this.msgCache[t] : this.msgCache[t] = r, n;
  }
  /**
   * 卸载一个事件监听
   * @param name 事件名称
   * @param handler 可选消息处理函数，如果不提供，则卸载所有指定消息名称的事件
   */
  off(t, n) {
    if (!n) {
      delete this.fnCache[t];
      return;
    }
    const r = this.fnCache[t];
    if (!r || r.length === 0)
      return;
    const i = r.findIndex((s) => s.fn === n);
    i >= 0 && r.splice(i, 1);
  }
  /**
   * 检查某个消息的监听函数数量
   * @param name 消息名称
   */
  count(t) {
    var n;
    return t ? ((n = this.fnCache[t]) == null ? void 0 : n.length) || 0 : -1;
  }
}
function se(e) {
  return e.replace(/(?:\r\n|\r)/g, `
`).replace(/(?:^\n*|\n*$)/g, "").replace(/ {2}/g, "　").replace(/<(\s*[a-zA-Z/]+?)/g, "&lt;$1").replace(/"/g, "&quot;").split(`
`).map(
    (t) => t.replace(/^\s{0,3}#\s{1}(.+)/, "<h1>$1</h1>").replace(/^\s{0,3}##\s{1}(.+)/, "<h2>$1</h2>").replace(/^\s{0,3}###\s{1}(.+)/, "<h3>$1</h3>").replace(/^\s{0,3}####\s{1}(.+)/, "<h4>$1</h4>")
  ).map((t) => {
    const n = t.startsWith(">>");
    return /^<h\d>/.test(t) ? t : `<p${n ? ' style="text-align:right"' : ""}>${(n ? t.slice(2) : t).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\[(.+?)\]\((.+?)\)/g, '<a traget="_blank" href="$2">$1</a>')}</p>`;
  }).join("");
}
function st(e) {
  return e ? e[0].toUpperCase() + e.slice(1) : "";
}
function _(e) {
  return e ? e[0].toLowerCase() + e.slice(1) : "";
}
const N = /_\w*/, E = /-\w*/;
function O(e) {
  const t = N.test(e) ? e.replace(/(?:^_*|_*$)/g, "").replace(/_+([^_])/g, (n, r) => r.toUpperCase()) : E.test(e) ? e.replace(/(?:^-*|-*$)/g, "").replace(/-+(\w)/g, (n, r) => r.toUpperCase()) : e;
  return _(t);
}
function oe(e) {
  return st(O(e));
}
function U(e) {
  return N.test(e) ? _(e).replace(/(?:^_*|_*$)/g, "").replace(/_+([^_])/g, (n, r) => "_" + r.toLowerCase()) : E.test(e) ? _(e.replace(/(?:^-*|-*$)/g, "")).replace(/-+(\w)/g, (n, r) => "_" + r.toLowerCase()) : _(e).replace(/[A-Z]/g, (n) => `_${n.toLowerCase()}`);
}
function ce(e) {
  return E.test(e) ? _(e).replace(/(?:^-*|-*$)/g, "").replace(/-+(\w)/g, (n, r) => "-" + r.toLowerCase()) : N.test(e) ? _(e).replace(/(?:^_*|_*$)/g, "").replace(/_+(\w)/g, (n, r) => "-" + r.toLowerCase()) : _(e).replace(/[A-Z]/g, (n) => `-${n.toLowerCase()}`);
}
const q = /^(?:https?:)?\/\/.+$/i, ot = /^https?:\/\/.+$/i, ct = /^\{[\d\D]*\}$/, ut = /^\[[\d\D]*\]$/;
function ue(e, t) {
  return !!e && !!t && t in e;
}
function D(e, t = !1) {
  return t ? q.test(e) : ot.test(e);
}
function le(e) {
  return q.test(e);
}
function ae(e) {
  return e == null;
}
function b(e, ...t) {
  return e !== null && typeof e == "object" && !(e instanceof Map) && !(e instanceof Set) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !Array.isArray(e) && t.every((n) => n in e);
}
function A(e, ...t) {
  if (!e || typeof e != "object")
    return !1;
  const n = Object.getPrototypeOf(e);
  return n !== Object.prototype && n !== null ? !1 : t.every((r) => r in e);
}
function lt(e, t) {
  return Array.isArray(e) && e.every((n) => t(n));
}
function at(e, t) {
  return A(e) && Object.keys(e).every((n) => t(e[n]));
}
function fe(e) {
  return b(e) && "then" in e && typeof e.then == "function";
}
function he(e) {
  return b(e) && Object.keys(e).every((t) => typeof t == "string");
}
function pe(e) {
  return typeof e != "number" || Number.isNaN(e) ? !1 : Number.isFinite(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function de(e) {
  return ct.test(e) || ut.test(e);
}
function ge(e) {
  return /MicroMessenger/i.test(e || navigator.userAgent);
}
function me(e) {
  return /QQBrowser|\sQQ\/|QBWebViewType/i.test(e || navigator.userAgent);
}
const ft = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, ht = /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/, pt = /^::(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, dt = /^::(?:[0-9a-fA-F]{1,4}:){0,5}[0-9a-fA-F]{1,4}$/, gt = /^(?:[0-9a-fA-F]{1,4}:){1,6}:$/, mt = /^(?:[0-9a-fA-F]{1,4}:){1,5}:(?:[0-9a-fA-F]{1,4}:){0,4}[0-9a-fA-F]{1,4}$/;
function Z(e) {
  const t = e.match(ft);
  return t ? t.slice(1, 5).map((n) => +n).every((n) => n >= 0 && n <= 255) : !1;
}
function K(e) {
  if (ht.test(e))
    return !0;
  const t = e.split(":");
  return t.length < 3 || t.length >= 8 ? !1 : e === "::" || pt.test(e) || dt.test(e) || gt.test(e) || mt.test(e);
}
function yt(e) {
  return Z(e) || K(e);
}
function W(e, t) {
  try {
    const n = JSON.parse(e);
    return t ? t(n) ? n : null : n;
  } catch {
    return null;
  }
}
function ye(e, t) {
  if (/^\{[\d\D]*\}$/.test(e) || /^\[[\d\D]*\]$/.test(e))
    try {
      const r = new Function(`try{return ${e}}catch(e){return null}`)();
      return t ? t(r) ? r : null : r;
    } catch {
      return null;
    }
  return null;
}
const L = "__" + Math.random().toString(32).slice(2) + "__", _t = new RegExp(`(?:"${L}|${L}")`, "g"), bt = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
function wt(e, t) {
  if (e === void 0)
    return "undefined";
  if (typeof e == "function")
    return V(e);
  try {
    const n = L;
    return JSON.stringify(
      e,
      function(r, i) {
        if (i instanceof RegExp)
          return `${n}RegExp(${i.toString()})${n}`;
        if (i instanceof Error)
          return `${n}${i.name}(${i.message})${n}`;
        if (i instanceof Map)
          return Object.fromEntries(i);
        if (i instanceof Set)
          return Array.from(i);
        if (i instanceof HTMLElement)
          return `${n}HTMLElement(${i.tagName.toLowerCase()})${n}`;
        if (i instanceof Promise)
          return `${n}Promise()${n}`;
        if (typeof WeakMap < "u" && i instanceof WeakMap || typeof WeakSet < "u" && i instanceof WeakSet || typeof WeakRef < "u" && i instanceof WeakRef || typeof ArrayBuffer < "u" && i instanceof ArrayBuffer || typeof DataView < "u" && i instanceof DataView)
          return `${n}${String(i)}${n}`;
        const s = typeof i;
        return s === "function" ? `${n}${V(i)}${n}` : s === "symbol" ? `${n}${String(i)}${n}` : s === "bigint" ? `${n}${String(i)}n${n}` : s === "number" && Number.isNaN(i) ? `${n}NaN${n}` : s === "number" && !Number.isFinite(i) ? `${n}${i > 0 ? "Infinity" : "-Infinity"}${n}` : s === "string" && bt.test(i) ? `${n}Date(${i})${n}` : i;
      },
      t
    ).replace(_t, "").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  } catch (n) {
    return `Error(${(n instanceof Error ? n.message : String(n)).replace(/\n[\d\D]+/, "")})`;
  }
}
function V(e) {
  return e.toString().replace(/\{[\d\D]*\}/, "{ [code] }");
}
function x(e, t = !1) {
  return typeof e == "string" ? O(e) : Array.isArray(e) ? e.map((n) => !t || typeof n == "string" ? x(n) : typeof n == "object" && n ? x(n, !0) : n) : A(e) ? Object.keys(e).reduce(
    (n, r) => {
      const i = O(String(r)), s = i.charAt(0).toLowerCase() + i.slice(1);
      return n[s] = t ? e[r] : x(e[r]), n;
    },
    {}
  ) : e;
}
function j(e, t = !1) {
  return typeof e == "string" ? U(e) : Array.isArray(e) ? e.map((n) => !t || typeof n == "string" ? j(n) : typeof n == "object" && n ? j(n, t) : n) : A(e) ? Object.keys(e).reduce(
    (n, r) => {
      const i = U(String(r));
      return n[i] = t ? e[r] : j(e[r]), n;
    },
    {}
  ) : e;
}
const _e = (e) => new Promise((t, n) => {
  const r = new FileReader();
  r.onload = function() {
    t(r.result);
  }, r.onerror = function() {
    n(r.error);
  }, r.readAsDataURL(e);
}), be = (e, t = "utf-8") => new Promise((n, r) => {
  const i = new FileReader();
  i.onload = function() {
    n(i.result);
  }, i.onerror = function() {
    r(i.error);
  }, i.readAsText(e, t);
});
async function we(e, t, n = "utf-8") {
  const r = typeof t == "function" ? t : null;
  return new Promise((i, s) => {
    const o = new FileReader();
    o.onload = function() {
      const u = o.result;
      i(r ? W(u, r) : W(u));
    }, o.onerror = function() {
      s(o.error);
    }, o.readAsText(e, typeof t == "string" ? t : n);
  });
}
function X(e, t) {
  return typeof t == "function" ? v(e, t) : t ? v(e, (n, r) => n[t] === r[t]) : $t(e);
}
function $t(e) {
  return Array.from(new Set(e));
}
function v(e, t) {
  return e.reduce((n, r) => (n.some((i) => t(r, i)) || n.push(r), n), []);
}
function $e(e, t, n) {
  const r = n || Ct, i = X([...e, ...t], n);
  if (typeof r != "function") {
    const s = r;
    return i.filter(
      (o) => e.findIndex((u) => o[s] === u[s]) === -1 || t.findIndex((u) => o[s] === u[s]) === -1
    );
  }
  return i.filter(
    (s) => e.findIndex((o) => r(s, o)) === -1 || t.findIndex((o) => r(s, o)) === -1
  );
}
function Ct(e, t) {
  return e === t;
}
const B = Object.prototype.hasOwnProperty;
function F(e, t) {
  var n, r, i, s;
  if (Array.isArray(e) && Array.isArray(t)) {
    const o = Math.max(e.length, t.length), u = {
      type: "array",
      children: []
    };
    for (let l = 0; l < o; l++) {
      const f = F(e[l], t[l]);
      for (const a of f)
        a.index = l, (n = u.children) == null || n.push(a);
    }
    return ((r = u.children) == null ? void 0 : r.length) === 0 ? [] : [u];
  }
  if (e instanceof Date && t instanceof Date)
    return +e == +t ? [] : [
      { type: "remove", data: e },
      { type: "add", data: t }
    ];
  if (e instanceof RegExp && t instanceof RegExp)
    return String(e) === String(t) ? [] : [
      { type: "remove", data: e },
      { type: "add", data: t }
    ];
  if (b(e) && b(t)) {
    const o = {
      type: "object",
      children: []
    }, u = X(Object.keys(e).concat(Object.keys(t)));
    for (const l of u) {
      const f = B.call(e, l) ? e[l] : void 0, a = B.call(t, l) ? t[l] : void 0, p = F(f, a);
      for (const h of p)
        h.index = l, (i = o.children) == null || i.push(h);
    }
    return ((s = o.children) == null ? void 0 : s.length) === 0 ? [] : [o];
  }
  return e === t ? [] : typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t) ? [] : e === void 0 ? [{ type: "add", data: t }] : t === void 0 ? [{ type: "remove", data: e }] : [
    { type: "remove", data: e },
    { type: "add", data: t }
  ];
}
function z(e, t, n = "", r = 0) {
  const i = e.type, s = " ".repeat(r), o = " ".repeat(r - t.indent);
  if (i === "remove" || i === "add")
    return wt(e.data, t.indent).split(`
`).map(
      (l, f) => t.wrapper(`${i === "remove" ? "-" : "+"}${f === 0 ? n : o}${l}`, i)
    );
  const u = e.children || [];
  return [
    i === "object" ? "{" : "[",
    ...function() {
      const l = [];
      for (const f of u) {
        const a = f.index ?? "?";
        l.push(...z(f, t, `${s}${a}: `, r + t.indent));
      }
      return l;
    }(),
    i === "object" ? o + "}" : o + "]"
  ].map((l, f) => (f === 0 ? n : "") + l);
}
const At = {
  indent: 2,
  wrapper: (e) => e
};
function Ce(e, t, n) {
  const r = Object.assign({}, At, n);
  r.indent = Math.min(10, Math.max(2, Math.ceil(r.indent)));
  const i = (n == null ? void 0 : n.return) || "string", s = [], o = F(e, t);
  if (i === "raw")
    return o;
  for (const u of o)
    s.push(...z(u, r, "", r.indent));
  return i === "array" ? s : s.join(`
`);
}
async function Ae(e) {
  return await new Promise(function(t) {
    const n = document.getElementsByTagName("head")[0], r = document.createElement("script");
    r.setAttribute("type", "text/javascript"), r.setAttribute("charset", "utf-8"), r.onload = function() {
      n.removeChild(r), t(!0);
    }, r.onerror = function() {
      n.removeChild(r), t(!1);
    }, r.setAttribute("src", e), n.appendChild(r);
  });
}
async function Se(e, t = 3e3, n = !1) {
  return await new Promise((r) => {
    const i = new Image();
    i.onload = function() {
      s && clearTimeout(s), r({ width: i.width, height: i.height, image: i });
    }, i.onerror = function() {
      s && clearTimeout(s), r(null);
    };
    const s = setTimeout(function() {
      r(!1);
    }, t);
    i.src = e;
  });
}
function G(e) {
  return Object.getOwnPropertyNames(e).forEach(function(t) {
    delete e[t];
  }), e;
}
const xe = G;
function St(e, t) {
  return G(e), Object.assign(e, t);
}
const je = St;
function xt(e, ...t) {
  const n = {};
  return Object.keys(e).forEach((r) => {
    const i = e[r];
    i != null && !Number.isNaN(i) && !t.includes(i) && (n[r] = i);
  }), n;
}
const ke = xt;
function Y(e) {
  return JSON.parse(JSON.stringify(e));
}
const Oe = Y;
function Le(e, ...t) {
  const n = { ...e };
  for (const r of t)
    delete n[r];
  return n;
}
function Fe(e, ...t) {
  const n = {};
  for (const r of t)
    n[r] = e[r];
  return n;
}
const jt = /(?:key|sk|secret|token|password|secure)/i;
function kt(e) {
  return jt.test(e);
}
function Ot(e, t) {
  const n = (t == null ? void 0 : t.keepLength) ?? !1, r = "*", i = r.repeat(6), s = (t == null ? void 0 : t.maxLength) ?? 1 / 0, o = e + "", u = o.length;
  return o ? u <= 6 ? n ? r.repeat(u) : i : o.slice(0, 3) + (n ? r.repeat(Math.min(u - 6, s < 9 ? 1 / 0 : s - 6)) : i) + o.slice(-3) : "";
}
function Ne(e, t) {
  return tt(e, t, 0);
}
function tt(e, t, n = 0) {
  const r = { ...e };
  if (n >= 5)
    return r;
  for (const i in r) {
    const s = e[i];
    typeof i == "string" && kt(i) && typeof s == "string" ? r[i] = Ot(s, t) : b(s) && (r[i] = tt(s, t, n + 1));
  }
  return r;
}
class Lt {
  constructor() {
    c(this, "_p", null);
    c(this, "_isIP", !1);
    c(this, "_allowed", []);
    c(this, "_disallow", []);
    c(this, "_optional", !1);
    c(this, "_null", !1);
  }
  pattern(t) {
    return this._p = t, this;
  }
  email() {
    return this._p = /^\w+(-+.\w+)*@\w+(-.\w+)*.\w+(-.\w+)*$/, this;
  }
  url(t) {
    return this._p = t ? /^(?:https?:)?\/\/.+$/i : /^https?:\/\/.+$/i, this;
  }
  isoTime() {
    return this._p = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/, this;
  }
  dataUri() {
    return this._p = /^data:[a-z]+\/[a-z]+;base64,[\w+/=]+$/, this;
  }
  phone() {
    return this._p = /^\d{11}$/, this;
  }
  ip(t) {
    return this._isIP = t || !0, this._p = null, this;
  }
  enum(...t) {
    return this._allowed = t, this._disallow = [], this;
  }
  allow(...t) {
    return this._allowed.push(...t), this;
  }
  disallow(...t) {
    return this._disallow.push(...t), this;
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    return t === void 0 ? this._optional : t === null ? this._null : typeof t != "string" || this._disallow.length > 0 && this._disallow.includes(t) ? !1 : this._allowed.length > 0 ? this._allowed.includes(t) : this._p ? this._p.test(t) : this._isIP === "v4" ? Z(t) : this._isIP === "v6" ? K(t) : this._isIP ? yt(t) : !0;
  }
}
class Ft {
  constructor() {
    c(this, "_int", !1);
    c(this, "_min", -1 / 0);
    c(this, "_max", 1 / 0);
    c(this, "_big", !1);
    c(this, "_time", "");
    c(this, "_allowed", []);
    c(this, "_disallowed", []);
    c(this, "_optional", !1);
    c(this, "_null", !1);
  }
  integer() {
    return this._int = !0, this._big = !1, this;
  }
  bigint() {
    return this._big = !0, this._int = !1, this;
  }
  min(t) {
    return this._min = t, this;
  }
  max(t) {
    return this._max = t, this;
  }
  enum(...t) {
    return this._allowed = t.map((n) => String(n)), this._disallowed = [], this;
  }
  allow(...t) {
    return this._allowed.push(...t.map((n) => String(n))), this;
  }
  disallow(...t) {
    return this._disallowed.push(...t.map((n) => String(n))), this;
  }
  timestamp(t) {
    return this._time = t || "", this;
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    if (t === void 0)
      return this._optional;
    if (t === null)
      return this._null;
    if (typeof t != "bigint" && typeof t != "number")
      return !1;
    const n = String(t);
    if (this._disallowed.length > 0 && this._disallowed.findIndex((i) => String(i) === n) >= 0)
      return !1;
    if (this._allowed.length > 0)
      return this._allowed.includes(n);
    const r = function(i) {
      const s = Date.now(), o = 100 * 365 * 24 * 60 * 60 * 1e3;
      return i >= s - o && i <= s + o;
    };
    return typeof t == "bigint" ? this._big ? this._time ? r(this._time === "unix" ? t * 1000n : t) : t >= this._min && t <= this._max : !1 : (this._int || this._time) && Math.ceil(t) !== t ? !1 : this._time ? r(this._time === "unix" ? t * 1e3 : t) : t >= this._min && t <= this._max;
  }
}
class Nt {
  constructor() {
    c(this, "_value", null);
    c(this, "_optional", !1);
    c(this, "_null", !1);
  }
  true() {
    return this._value = !0, this;
  }
  false() {
    return this._value = !1, this;
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    return t === void 0 ? this._optional : t === null ? this._null : typeof t == "boolean" && (this._value !== null ? this._value === t : !0);
  }
}
class Et {
  constructor(t) {
    c(this, "_fields");
    c(this, "_plain", !1);
    c(this, "_xor");
    c(this, "_optional", !1);
    c(this, "_null", !1);
    this._fields = t, this._xor = [];
  }
  xor(...t) {
    this._xor.push(t);
  }
  plain() {
    return this._plain = !0, this;
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    if (t === void 0)
      return this._optional;
    if (t === null)
      return this._null;
    if (!b(t) || this._plain && !A(t))
      return !1;
    for (const n in this._fields) {
      const r = this._fields[n], i = n in t ? t[n] : void 0;
      if (!(r != null && r.validate(i)))
        return !1;
    }
    return !0;
  }
}
class Rt {
  constructor(t) {
    c(this, "_items");
    c(this, "_optional", !1);
    c(this, "_null", !1);
    this._items = Array.isArray(t) ? t : [t];
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    return t === void 0 ? this._optional : t === null ? this._optional : Array.isArray(t) ? t.every((n) => this._items.some((r) => r.validate(n))) : !1;
  }
}
class Mt {
  constructor(t) {
    c(this, "_schema");
    c(this, "_optional", !1);
    c(this, "_null", !1);
    this._schema = t;
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    return t === void 0 ? this._optional : t === null ? this._null : !Array.isArray(t) || t.length !== this._schema.length ? !1 : t.every((n, r) => this._schema[r].validate(n));
  }
}
class Pt {
  constructor(t) {
    c(this, "_schema");
    c(this, "_optional", !1);
    c(this, "_null", !1);
    this._schema = t;
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    return t === void 0 ? this._optional : t === null ? this._null : this._schema.some((n) => n.validate(t));
  }
}
class Tt {
  constructor(t) {
    c(this, "_gurad");
    c(this, "_optional", !1);
    c(this, "_null", !1);
    this._gurad = t;
  }
  optional() {
    return this._optional = !0, this;
  }
  maybeNull() {
    return this._null = !0, this;
  }
  validate(t) {
    return t === void 0 ? this._optional : t === null ? this._null : this._gurad(t);
  }
}
const It = {
  object(e) {
    return new Et(e);
  },
  array(e) {
    return new Rt(e);
  },
  tuple(...e) {
    return new Mt(e);
  },
  string() {
    return new Lt();
  },
  boolean() {
    return new Nt();
  },
  number() {
    return new Ft();
  },
  union(e) {
    return new Pt(e);
  },
  custom(e) {
    return new Tt(e);
  }
};
function Ee(e, t) {
  return t.validate(e);
}
function Re(e, t = "数据未能正确识别") {
  return typeof e == "function" ? {
    guard: e,
    message: t
  } : {
    guard: e.guard,
    message: e.message || t
  };
}
function Me(e) {
  return (t) => lt(t, e);
}
function Pe(e) {
  return (t) => at(t, e);
}
function Te(e) {
  const t = It.object(e);
  return function(n) {
    return t.validate(n);
  };
}
function Ie(e, t = "") {
  return !t || D(e, !0) ? J(e) : (J(t) + "/" + e).replace(/\/{2,}/g, "/").replace(/:\//, "://");
}
function J(e) {
  return D(e, !0) ? e.startsWith("http") ? e : ("location" in globalThis ? location.protocol : "https:") + e : ("location" in globalThis ? location.origin : "http://127.0.0.1") + "/" + e.replace(/^\/+/, "");
}
function C(e, t) {
  const n = {};
  return (e.match(/([^=&#?]+)=[^&#]*/g) || []).forEach(function(i) {
    const s = i.split("="), o = s[0], u = decodeURIComponent(s[1] || "");
    n[o] !== void 0 ? n[o] += "," + u : n[o] = u;
  }), t !== !0 ? n[t] || "" : n;
}
function et(e, t) {
  if (t) {
    if (t === !0)
      return e.replace(/\?[^#]*/, "");
  } else
    return e;
  const n = e.split("#"), r = n[0].split("?"), i = r[0], s = r.length > 1 ? r[1] : "", o = n.length > 1 ? "#" + n[1] : "", u = typeof t == "string" ? [t] : Array.isArray(t) ? t : [];
  return !u.length || !s ? n[0] + o : (u.map((l) => l.replace(/([\\(){}[\]^$+\-*?|])/g, "\\$1")), (i + "?" + s.replace(new RegExp("(?:^|&)(?:" + u.join("|") + ")=[^&$]+", "g"), "").replace(/^&/, "")).replace(/\?$/, "") + o);
}
function Ut(e, t, n = !1) {
  const r = typeof t == "string" ? t : Object.keys(t).map((o) => `${o}=${encodeURIComponent(t[o])}`).join("&");
  if (!r)
    return e;
  const i = e.split("#");
  n && (i[0] = et(
    i[0],
    (r.match(/([^=&#?]+)=[^&#]+/g) || []).map((o) => o.replace(/=.+$/, ""))
  ));
  const s = i[0].indexOf("?") + 1 ? "&" : "?";
  return (i[0] + s + r + (i.length > 1 ? "#" + i[1] : "")).replace(/\?&/, "?");
}
function Wt(e) {
  return e === !0 ? C(location.search, !0) : C(location.search, e);
}
const Ue = Wt;
function We(e) {
  return e === !0 ? C(location.hash, !0) : C(location.hash, e);
}
function Ve(e) {
  return et(document.URL, e);
}
function ve(e, t = !1) {
  return Ut(document.URL, e, t);
}
/*! ucsv v1.2.0 2014-04-09
 * Copyright 2014 Peter Johnson
 * Licensed MIT, GPL-3.0
 * https://github.com/uselesscode/ucsv
 */
const R = /^\d+$/, M = /^\d*\.\d+$|^\d+\.\d*$/, Vt = /^\s|\s$|,|"|\n/;
function vt(e) {
  return e.charAt(e.length - 1) !== `
` ? e : e.substring(0, e.length - 1);
}
function $(e) {
  if (typeof e == "string") {
    const t = e.replace(/"/g, '""');
    if (t === "")
      return '""';
    if (Vt.test(t) || R.test(t) || M.test(t))
      return '"' + t + '"';
  }
  return typeof e == "number" ? e.toString(10) : e == null ? "" : e.toString();
}
function Be(e) {
  let t, n = "", r, i, s;
  for (i = 0; i < e.length; i += 1) {
    for (r = e[i], s = 0; s < r.length; s += 1)
      t = r[s], t = $(t), n += s < r.length - 1 ? t + "," : t;
    n += `
`;
  }
  return n;
}
function Bt(e, t = {}) {
  const n = vt(e);
  let r = "", i = !1, s = !1, o = "", u = [];
  const l = [], f = t.trim === !0;
  let a;
  const p = function(h) {
    const d = h.trim();
    if (s !== !0) {
      if (h === "")
        return null;
      if (f === !0 && (h = d), R.test(d) || M.test(d))
        return +d;
    }
    return h;
  };
  for (a = 0; a < n.length; a += 1)
    r = n.charAt(a), i === !1 && (r === "," || r === `
`) ? (o = p(o) || "", u.push(o), r === `
` && (l.push(u), u = []), o = "", s = !1) : r !== '"' ? o += r : i ? n.charAt(a + 1) === '"' ? (o += '"', a += 1) : i = !1 : (i = !0, s = !0);
  return o = p(o) || "", u.push(o), l.push(u), l;
}
function Je(e, t = {}) {
  let n = t.columns;
  const r = Bt(e, { trim: !!t.trim });
  n || (n = r.shift());
  const i = n.length;
  return r.map(function(s) {
    const o = {};
    let u = 0;
    for (; u < i; u += 1)
      o[n[u]] = s[u];
    return o;
  });
}
function Jt(e, t = {}) {
  let n = t.columns;
  const r = t.includeColumns ?? !0;
  let i = "", s = "";
  return n !== void 0 ? i = function() {
    let l = "", f, a, p;
    const h = n || [], d = e.length, g = h.length;
    for (a = 0; a < d; a += 1) {
      const m = e[a];
      for (p = 0; p < g; p += 1)
        f = h[p], l += $(m[f]), l += p < g - 1 ? "," : "";
      l += `
`;
    }
    return l;
  }() : i = function() {
    const l = [], f = e.length, a = [];
    let p = -1, h, d, g, m, w;
    for (g = 0; g < f; g += 1) {
      h = e[g], w = [];
      for (d in h)
        if (Object.prototype.hasOwnProperty.call(h, d)) {
          const y = d;
          m = l.indexOf(y), m === -1 && (m = l.push(y), m -= 1), w[m] = $(h[y]);
        }
      g === 0 && (p = w.length), a.push(w);
    }
    const P = l.length;
    return p !== P && a.forEach(function(y) {
      y.length = P;
    }), n = l, a.map(function(y) {
      return y.join(",");
    }).join(`
`) + `
`;
  }(), r && n && (n.forEach(function(l) {
    s += $(l) + ",";
  }), s = s.substring(0, s.length - 1), i = s + `
` + i), i;
}
function Qe(e, t, n) {
  const r = Jt(Ht(e, n == null ? void 0 : n.fixNumber), { columns: n == null ? void 0 : n.columns }), i = new Uint8Array([239, 187, 191]), s = new Blob([i, r], { type: "text/csv; charset=utf8" }), o = document.createElement("a");
  o.href = URL.createObjectURL(s), o.download = `${t || "data"}.csv`, document.body.appendChild(o), o.click(), document.body.removeChild(o);
}
const Qt = Object.prototype.hasOwnProperty;
function Ht(e, t) {
  if (!t)
    return e;
  const n = Y(e), r = Math.min(12, Math.max(4, t.minLength ?? 10)), i = t.prefix || "", s = t.postfix || "";
  for (const o of n)
    if (typeof o == "object" && o !== null)
      for (const u in o)
        Qt.call(o, u) && (o[u] = qt(o[u], r, i, s));
  return n;
}
function qt(e, t, n, r) {
  if (!n && !r)
    return e;
  if (typeof e == "string" && (R.test(e) || M.test(e)) && e.length >= t)
    return H(e, n, r);
  if (typeof e == "number" && Number.isFinite(e)) {
    const i = e.toString(10);
    if (i.length >= t)
      return H(i, n, r);
  }
  return e;
}
const Q = {
  ensp: " ",
  thinsp: " ",
  quote: "'"
};
function H(e, t, n) {
  return `${Q[t] || t}${e}${Q[n] || n}`;
}
export {
  re as CustomError,
  ie as EventBus,
  ee as Queue,
  ve as addPara,
  Ut as addParamsToString,
  Be as arrayToCsv,
  Kt as asyncNoop,
  O as camelCase,
  x as camelize,
  st as capitalize,
  Ht as convertNumberToStringForCsv,
  Y as copyObject,
  Gt as copyText,
  Bt as csvToArray,
  Je as csvToObject,
  $e as difference,
  Ne as encodeSecretData,
  Ot as encodeWithStars,
  Qe as exportCsvFile,
  ye as formatJSON,
  it as getCustomErrorClass,
  te as getEmptySVG,
  zt as getFileSizeDescription,
  Ie as getFullURL,
  We as getHash,
  Yt as getOSPlatform,
  Ue as getPara,
  C as getParaFromString,
  Xt as getRandomString,
  Re as getTypeGuard,
  Ee as is,
  lt as isArray,
  ae as isEmpty,
  D as isFullURL,
  yt as isIP,
  Z as isIPv4,
  K as isIPv6,
  de as isJsonLike,
  at as isMap,
  b as isObject,
  A as isPlainObject,
  fe as isPromiseLike,
  me as isQQPlatform,
  pe as isSafeNumber,
  he as isStringRecord,
  le as isUrl,
  ue as isValidKey,
  ge as isWXPlatform,
  Ce as jsonDiff,
  ce as kebabCase,
  Se as loadImage,
  Ae as loadJS,
  kt as maybeSecretKey,
  Zt as noop,
  Oe as objectCopy,
  ke as objectPure,
  je as objectReplace,
  xe as objectReset,
  Jt as objectToCsv,
  Le as omitFields,
  ne as parallelJob,
  W as parseJSON,
  oe as pascalCase,
  Fe as pickFields,
  xt as pureObject,
  Wt as queryString,
  _e as readAsDataURI,
  we as readAsJson,
  be as readAsText,
  Ve as removePara,
  et as removeParamsFromString,
  St as replaceObject,
  G as resetObject,
  T as sleep,
  U as snakeCase,
  j as snakify,
  wt as stringify,
  se as textFormater,
  Me as typedArrayGuard,
  Pe as typedMapGuard,
  Te as typedObjectGuard,
  _ as uncapitalize,
  X as unique,
  It as validator
};
